import {
  MuiEvent,
  GridRowId,
  GridEventListener,
  GridRowModesModel,
  GridRowModes,
  GridRowModel,
  GridRowParams,
} from "@mui/x-data-grid-pro"

export class EditorState {
  rowModes: GridRowModesModel = {};
}
